import { Map } from 'immutable';
// import * as t from '../../actions/friendProfileActionType';

const initialState = Map({
  myStatsData: {},
  pointsThisWeek: null,
  rank: null,
  loginStreak: null,
  longestLoginStreak: null,
  pointsThisWeekWaiting: false,
  loginStreakWaiting: false,
});

const reducer = function friendStatsReducer(state = initialState, action) {
  switch (action.type) {
    // case t.SET_STATS:
    //   return state.set('myStatsData', action.statsData);
    // case t.SET_POINTS_THIS_WEEK_WAITING:
    //   return state.set('pointsThisWeekWaiting', action.value);
    // case t.SET_LOGIN_STREAK_WAITING:
    //   return state.set('loginStreakWaiting', action.value);
    // case t.SET_POINTS_THIS_WEEK:
    //   return state
    //     .set('pointsThisWeek', action.data.pointsThisWeek)
    //     .set('rank', action.data.rank);
    // case t.SET_LOGIN_STREAK:
    //   return state
    //     .set('loginStreak', action.data.loginStreak)
    //     .set('longestLoginStreak', action.data.longestLoginStreak);
    default:
      return state;
  }
};

export default reducer;
